import { TrackedWalletTableTradeCell } from './tracked-wallet-table-trade-cell'

import type { ClassNameProps } from '@root/shared/react'
import type BigNumber from 'bignumber.js'

type TrackedWalletTableBoughtCellProps = {
  buys: number
  buyVolumeInUsd: BigNumber
  buyVolumeCurrency: BigNumber
} & ClassNameProps

export const TrackedWalletTableBoughtCell: React.FC<
  TrackedWalletTableBoughtCellProps
> = (props) => {
  return (
    <TrackedWalletTableTradeCell
      color={'green'}
      volumeInUsd={props.buyVolumeInUsd}
      volumeCurrency={props.buyVolumeCurrency}
      number={props.buys}
    />
  )
}
